var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.05 6.72h-8.05v13.21h8.1z",
    fill: "#ff5f00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.79 13.33a8.35 8.35 0 0 1 3.21-6.61 8.41 8.41 0 0 0 -12.32 11.07 8.46 8.46 0 0 0 3.45 3.1 8.46 8.46 0 0 0 8.87-.95 8.39 8.39 0 0 1 -3.21-6.61z",
    fill: "#eb001b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m33.6 13.33a8.4 8.4 0 0 1 -13.6 6.6 8.42 8.42 0 0 0 2.37-10.28 8.56 8.56 0 0 0 -2.37-2.94 8.46 8.46 0 0 1 8.87-1 8.4 8.4 0 0 1 4.73 7.56z",
    fill: "#f79e1b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMastercard);
export default __webpack_public_path__ + "static/media/card-mastercard.1c9c144993623189001e8ff2325e9908.svg";
export { ForwardRef as ReactComponent };